import { lazy } from 'react';

const GamificationProfilePage = lazy(() => import('../pages/Profile'));
const GamificationRankingPage = lazy(() => import('../pages/Ranking'));
const GamificationRulesPage = lazy(() => import('../pages/Rules'));

export const GamificationRoutes = [
  {
    path: '/game/perfil',
    element: <GamificationProfilePage />,
  },
  {
    path: '/game/ranking',
    element: <GamificationRankingPage />,
  },
  {
    path: '/game/rules',
    element: <GamificationRulesPage />,
  },
];
